export default function formatPhone(phone) {
    return String(phone)
        .replace(/([^0-9])/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};
